var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-file"},[_c('button',{staticClass:"gui-btn gui-btn--upload js-upload-file",on:{"click":function($event){$event.preventDefault();return _vm.onChooseFileClick($event)}}},[_vm._v("Выберите файл")])])}
var staticRenderFns = []

export { render, staticRenderFns }